module.exports = __webpack_public_path__ + "assets/albya-alt.a8b24eab.svg";